import React from 'react';
import { css } from '@emotion/css';
import { BaseLoginButton } from '../../ui/base-login-button/base-login-button';
import { FaFacebook } from 'react-icons/fa6';
import { useSocialLogin } from '../../hooks/auth-api.hooks';

const facebookButtonStyle = css({
  backgroundColor: '#1877F2',
  color: 'var(--primary-color)',
  border: 'none',
  boxShadow: '0 4px 12px rgba(24, 119, 242, 0.2)',
  ':hover:not(:disabled)': {
    backgroundColor: '#0b5fcc',
    boxShadow: '0 6px 15px rgba(24, 119, 242, 0.3)',
  },
});

const contentWrapper = css({
  display: 'flex',
  alignItems: 'center',
  width: '100%',
  position: 'relative',
  padding: '0 0 0 24px',
});

const iconStyle = css({
  position: 'absolute',
  left: 0,
  fontSize: '20px',
  height: '20px',
  width: '20px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  '@media (max-width: 920px)': {
    fontSize: 'var(--fs-350)',
    height: 'var(--fs-350)',
    width: 'var(--fs-350)',
  },
});

const textStyle = css({
  flex: 1,
  textAlign: 'center',
});

export interface FacebookButtonProps extends Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, 'children' | 'onClick'> {
  onSuccess?: (user: any) => void;
  redirectUrl?: string;
}

export const FacebookButton: React.FC<FacebookButtonProps> = ({ className, onSuccess, redirectUrl, ...rest }) => {
  const { mutate: socialLogin, isPending } = useSocialLogin();

  const handleFacebookLogin = () => {
    console.log('[FacebookButton] Starting Facebook login...');
    socialLogin(
      { provider: 'facebook', redirectUrl },
      {
        onSuccess: (response) => {
          console.log('[FacebookButton] Login response received:', response);
          
          // Validate that we have the authorization URL
          if (!response?.authorizationUrl) {
            console.error('[FacebookButton] ERROR: No authorizationUrl in response', response);
            return;
          }

          // Store the redirect URL in sessionStorage so the callback handler can retrieve it
          if (redirectUrl) {
            console.log('[FacebookButton] Storing redirect URL:', redirectUrl);
            sessionStorage.setItem('social_login_redirect_url', redirectUrl);
          }
          
          console.log('[FacebookButton] Redirecting to Facebook authorization URL...');
          window.location.href = response.authorizationUrl;
        },
        onError: (error: any) => {
          console.error('[FacebookButton] Login error:', {
            message: error?.message,
            status: error?.response?.status,
            data: error?.response?.data,
            error,
          });
        },
      }
    );
  };

  return (
    <BaseLoginButton 
      className={`${facebookButtonStyle} ${className || ''}`} 
      onClick={handleFacebookLogin}
      disabled={isPending}
      {...rest}
    >
      <div className={contentWrapper}>
        <FaFacebook className={iconStyle} />
        <span className={textStyle}>Continue com Facebook</span>
      </div>
    </BaseLoginButton>
  );
};
